import {useLayoutEffect} from 'react'

function useScroll(selector) {
  useLayoutEffect(() => {
    const slider = document.querySelector(selector);
    let isDown = false;
    let startX;
    let scrollLeft;
    const mouseDown = (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    }
    const mouseLeave = () => {
      isDown = false;
    }
    const mouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      e.stopPropagation();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    }

    slider.addEventListener('mousedown', mouseDown);
    slider.addEventListener('mouseleave', mouseLeave);
    slider.addEventListener('mouseup', mouseLeave);
    slider.addEventListener('mousemove', mouseMove);
    
    return () => {
      slider.removeEventListener('mousedown', mouseDown);
      slider.removeEventListener('mouseleave', mouseLeave);
      slider.removeEventListener('mouseup', mouseLeave);
      slider.removeEventListener('mousemove', mouseMove);
    };
  }, [selector]);
}

export default useScroll